import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Хранит индексы родительских мапперов, полностью описывающих текущий скоуп
 */

export var ScopeKeychain = /*#__PURE__*/function () {
  function ScopeKeychain() {
    var _this = this;
    var vector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ScopeKeychain);
    this.vector = vector;
    _defineProperty(this, "toUniqueId", function (nodeId) {
      return [nodeId].concat(_toConsumableArray(Object.values(_this.vector).join('/'))).join('_');
    });
  }
  _createClass(ScopeKeychain, [{
    key: "cloneWithKey",
    value: function cloneWithKey(scopeId, scopeIndex) {
      return new ScopeKeychain(_objectSpread(_objectSpread({}, this.vector), {}, _defineProperty({}, scopeId, scopeIndex)));
    }
  }, {
    key: "getScopeIndex",
    value: function getScopeIndex(scopeId) {
      if (!(scopeId in this.vector)) throw Error('Attempting to retrieve non existent scopeId from keychain');
      return this.vector[scopeId];
    }
  }]);
  return ScopeKeychain;
}();